import Results from "../components/Results/Results";

function ResultsPage() {
  return (
    <Results />
  );
}

export default ResultsPage;